import React, { useEffect, useState } from "react";
import { Modal, NotificationToaster } from "components/notifications";
import { Button, ButtonSave } from "components/buttons";
import { Intent } from "@blueprintjs/core";
import { LicenceCheckingService } from "services";
import { PermissionsSelector } from "pages/licence-checking/shared/permissions-selector";
import { LicenceCheckingSharedData } from "pages/licence-checking/shared";
import PropTypes from "prop-types";
import { useDirtyData } from "hooks/useDirtyData";

export function LicenceCheckingEditUserModal({
  isOpen = false,
  onClose = () => {},
  user = {}
}) {
  const [isSaving, setIsSaving] = useState(false);
 const [originalPermissions, setOriginalPermissions] = useState([]);
 const [permissions, setPermissions] = useState([]);

 const isDataDirty = useDirtyData(
         originalPermissions,
         permissions
     );

  useEffect(() => {
    if (isOpen && user) {
      let tempPermissions = LicenceCheckingSharedData.getPermissions();
      tempPermissions[0].selected = user.allowPurchaseCredits;
      tempPermissions[1].selected = user.performManualChecks;
      tempPermissions[2].selected = user.allowAccessGreyFleet;
      setPermissions(tempPermissions);
      setOriginalPermissions(tempPermissions);
    }
  }, [isOpen, user]);

  function handlePermissionChange(event, identifier) {
    event.persist();

    setPermissions((prevPermissionData) => {
      return prevPermissionData.map((permission) => {
        if (permission.id === identifier) {
          return {
            ...permission,
            selected: event.target.checked,
          };
        }

        return permission;
      });
    });
  }

  function handleSave() {
    setIsSaving(true);

    if (!user) {
      NotificationToaster.show(Intent.DANGER, "User not found");
      setIsSaving(false);
      return;
    }

    let userPermissions = {
      allowPurchaseCredits: permissions[0].selected,
      allowManualChecking: permissions[1].selected,
      allowAccessGreyFleet: permissions[2].selected,
    };

    LicenceCheckingService.editLicenceCheckingUser(user.userId, userPermissions)
      .then(
        () => {
          NotificationToaster.show(
            Intent.SUCCESS,
            "User roles updated successfully"
          );
          setOriginalPermissions(permissions);
          closeModal();
        },
        () => {
          NotificationToaster.show(
            Intent.DANGER,
            "Failed to update user roles"
          );
        }
      )
      .catch(() => {
        NotificationToaster.show(Intent.DANGER, "Failed to update user roles");
      })
      .finally(() => {
        setIsSaving(false);
      });
  }

  function closeModal() {
    let tempPermissions = LicenceCheckingSharedData.permissions;
    setPermissions(tempPermissions);
    onClose();
  }

  return (
    <Modal
      title={<h2>Edit Licence Checking Role</h2>}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <>
        <PermissionsSelector
          permissions={permissions}
          handlePermissionChange={handlePermissionChange}
        />

        <div className="inline-items push-right spacer-top">
          <Button text="CANCEL" onClick={onClose} disabled={isSaving} />
          <ButtonSave
            text="SAVE AND CLOSE"
            intent={Intent.PRIMARY}
            onClick={handleSave}
            loading={false}
            disabled={isSaving}
            simpleDisabled={!isDataDirty}
            icon="floppy-disk"
          />
        </div>
      </>
    </Modal>
  );
}

LicenceCheckingEditUserModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  user: PropTypes.object.isRequired,
};

